// Alert.js
import React from "react";

export default function Alert({ show, onClose, message }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white text-gray-900 p-8 rounded-xl shadow-2xl relative  max-w-[600px] min-h-[100px]">
        {/* <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 text-2xl leading-none hover:text-gray-700"
        >
          &times;
        </button> */}
        <div className="text-xl font-medium text-center flex-1 flex items-center justify-center mb-8" style={{whiteSpace:"pre-wrap"}}>
          {message} 
        </div>
        <p></p>
         <div className="flex justify-center mt-10">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
